export default __webpack_public_path__ + "static/media/part_2_con1_02.8a6c8b6d.gif";